import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";
import { createContext } from "react";

const BrazilianRealEstateFundContext = createContext<IBrazilianRealEstateFundTopLevelFragment | null>(null);

export default BrazilianRealEstateFundContext;
